import $ from 'jquery'
window.$ = window.jQuery = $;

$.migrateMute = true;
$.migrateTrace = false;

import './app/jquery4-compat';

import './bootstrap';

// Animate.css
import 'animate.css';

// Animate On Scroll

import aos from 'aos';
window.AOS = aos

// Bootbox
import bootbox from 'bootbox';
window.bootbox = bootbox;

// Bootstrap Table
import('bootstrap-table');

// Bootstrap Table - Extensions - Table Mobile
import('bootstrap-table/src/extensions/mobile/bootstrap-table-mobile.js');

// Chosen
import('chosen-js');

// Flatpickr

import { Dutch } from 'flatpickr/dist/l10n/nl';
import { German } from 'flatpickr/dist/l10n/de';
import { French } from 'flatpickr/dist/l10n/fr';
import { Spanish } from 'flatpickr/dist/l10n/es';
import { Italian } from 'flatpickr/dist/l10n/it';

const languageMap = {
    nl: Dutch,
    de: German,
    fr: French,
    es: Spanish,
    it: Italian,
};

window.flatpickr = require('flatpickr');

window.flatpickrLanguageSwitch = (locale = 'en') => {
    return languageMap[locale] || undefined;
};

// GLightbox

import glightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';
window.GLightbox = glightbox

// jQuery UI - autocomplete
import 'jquery-ui/ui/widgets/autocomplete.js';

// NProgress

import nprogress from 'nprogress';
window.NProgress = nprogress;

// Password strength localization map
window.pwStrengthTranslator = require('./app/password.js').setupPwStrengthTranslator(window.locale || 'en');

// PureCounter
import PureCounter from "@srexi/purecounterjs";
const pure = new PureCounter();

// Signature Pad

import SignaturePad from 'signature_pad';
window.SignaturePad = SignaturePad;

// SweetAlert2

import Swal from 'sweetalert2';
window.Swal = Swal;

// Swiper

import Swiper from 'swiper/bundle';
window.Swiper = Swiper;

// Typed

import typed from 'typed.js';
window.Typed = typed;

// App

// require ('./app/actions.js');
require ('./app/backToTop.js');
// require ('./app/can.js');
require ('./app/chosen.js');
// require ('./app/colorCellStyle.js');
require ('./app/cookieBanner.js');
require ('./app/datepicker.js');
require ('./app/i18n.js');
require ('./app/logout.js');
require ('./app/nbrogress.js');
require ('./app/ready.js');
require ('./app/sections/blog.js');
require ('./app/sticky.js');
require ('./app/swiper.js');
// require ('./app/tables.js');
// require ('./app/tabs.js');
require ('./app/validation.js');
require ('./app/whatsApp.js');
